import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component, Ref } from '@eastsideco/salvo-ts';

import './TrustPilotMicroWidget.scss';

@Component
export class TrustPilotMicroWidget extends ThemeComponent {
    @Ref() seeReviews!: HTMLButtonElement;

    init() {
        if (this.seeReviews) {
            this.$listen(this.seeReviews, 'click', () => {
                const targetElement = document.querySelector('.tp-widget-mb-mt');

                if (targetElement) {
                    targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            });
        }
    }
}
